import { JobBoardHook } from "../hooks/JobBoard/jobBoard";
import { IndustriesHook } from "../hooks/JobBoard/industries";
import { JobTypeHook } from "../hooks/JobBoard/jobTypes";
import { PrReqsHook } from "../hooks/JobBoard/prReqs";
import { LocationsHook } from "../hooks/JobBoard/locations";
import { SearchHook } from "../hooks/JobBoard/search";
import { SearchButtonHook } from "../hooks/JobBoard/searchButton";
import JobBoardCards from "../components/JobBoard/jobBoardCards";
import SearchBar from "../components/JobBoard/searchBar";
import Filters from "../components/JobBoard/filters";
import FiltersMobile from "../components/JobBoard/filtersMobile";
import SearchBarMobile from "../components/JobBoard/searchBarMobile";
import { useState } from "react";

const JobBoard = () => {
    let jobsData = [];
    jobsData = JobBoardHook();
    let { industries, addIndustry, deleteIndustries } = IndustriesHook();
    let { jobTypes, addJobType, deleteJobTypes } = JobTypeHook();
    let { prReqs, addPrReq, deletePrReqs } = PrReqsHook();
    let { locations, setLocations, addLocationMobile, deleteLocationsMobile } = LocationsHook();
    let { search, setSearch, deleteSearch } = SearchHook();
    let { isValid, searchPress, cardsLength }= SearchButtonHook();
    const [popup, setPopup] = useState(false);

    let filters = {
        "search": search,
        "locations": locations,
        "industries": industries,
        "jobTypes": jobTypes,
        "prReqs": prReqs,
    }


    return (
    <div>
        <style>
        @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap');
        </style>
        <div class = {!popup? "grid": "hidden"}>
            <div class = "grid grid-cols-12 md:px-16 xl:px-24 backgroundS md:gap-x-5 lg:gap-x-10 gap-y-10 md:gap-y-16 pt-20">
                <div class = "col-span-12 px-8 md:px-0 xl:px-20">
                    <p class = "section-heading xl:px-36 text-section-heading-mobile md:text-section-heading text-primary-purple pb-6">
                        Stint is the job board for international students and graduates in Australia.
                    </p>
                    <p class = "paragraph-two text-paragraph-two-mobile md:text-paragraph-two pb-10">
                        Find jobs without citizenship or PR requirements from Australian employers that hire international students.
                    </p>
                    <div class = 'hidden md:grid relative z-40'>
                        {SearchBar(locations, setLocations, setSearch, filters, searchPress, deleteSearch, deleteIndustries, deleteJobTypes, deletePrReqs)}
                    </div>
                    <div class = 'md:hidden relative z-40'>
                        {SearchBarMobile(locations, setLocations, setSearch, filters, searchPress, deleteSearch, deleteIndustries, deleteJobTypes, deletePrReqs)}
                    </div>
                </div>
                <div class = "hidden md:grid col-span-3">
                    {Filters(addIndustry, addJobType, addPrReq, deleteIndustries, deleteJobTypes, deletePrReqs, searchPress, filters)}
                </div>
                <div class = "col-span-12 md:col-span-9 z-0">
                    {jobsData.length?
                    <div>
                        {JobBoardCards(jobsData, isValid, cardsLength, setPopup)}
                    </div>:
                    <div class = "col-span-12 pt-8 h-screen z-0">
                        <span class = "pt-5 sub-heading text-sub-heading-mobile md:text-sub-heading ">Loading Jobs</span>
                        <div class="text-center pt-5 w-full">
                            <div role="status">
                                <svg class="inline mr-2 w-8 h-8 text-white animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                                <span class="sub-heading text-sub-heading-mobile md:text-sub-heding sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
        <div class = {popup? "grid": "hidden"}>
            {FiltersMobile(addIndustry, addJobType, addPrReq, deleteIndustries, deleteJobTypes, deletePrReqs, searchPress, filters, setPopup, addLocationMobile, deleteLocationsMobile)}
        </div>

    </div>
    );
  };

export default JobBoard;